import { Launch as LaunchIcon } from '@mui/icons-material'
import { Link } from '@mui/material'
import { useState } from 'react'

import Lightbox from '@/components/Lightbox'

interface Props {
  reportUrl: string
  customerId: string
  subjectId: string
}

const ViewReportLink: React.FC<Props> = ({ reportUrl, customerId, subjectId }) => {
  const [isReportOpen, setIsReportOpen] = useState<boolean>(false)

  return (
    <>
      <Link
        component="button"
        type="button"
        onClick={() => setIsReportOpen(true)}
        underline="none"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          fontSize: '12px',
          fontWeight: 400,
          color: 'primary.main',
          width: 'fit-content',
        }}
      >
        View report
        <LaunchIcon sx={{ fontSize: '16px' }} />
      </Link>

      {isReportOpen && (
        <Lightbox
          images={[
            {
              documentReference: reportUrl,
              thumbnail: reportUrl,
              type: 'Open Banking Report',
            },
          ]}
          onClose={() => setIsReportOpen(false)}
          customerId={customerId}
          subjectId={subjectId}
        />
      )}
    </>
  )
}

export default ViewReportLink
